module.exports = __webpack_public_path__ + "static/media/Voucher Pay Logo.d67a3821.svg";